import React from 'react';
import { HeadlineLarge } from '@shared/ui/atoms/fonts/Headline';
import { isInTeams } from '@shared/utils/TeamsUtils';
import { BodyLarge } from '@shared/ui/atoms/fonts/Body';
import { Trans, useTranslation } from "react-i18next";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { useDispatch } from "react-redux";
import { setAddTeamMemberView } from "../ducks/add-users.duck";
import { AddTeamMemberView } from "../ducks/AddUsers.model";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function UserLimitReached(props: Props) {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const onClick = () => {
    dispatch(setAddTeamMemberView(AddTeamMemberView.AddUser));
  }
  return (
    <>
      <HeadlineLarge style={{marginBottom: 12}}>{t('settings.member-limit-reached')}</HeadlineLarge>

      {isInTeams() ? <>
        <BodyLarge style={{marginBottom: 24}}>{t('settings.account-full-in-teams')}</BodyLarge>
      </> : <>
        <BodyLarge style={{marginBottom: 24}}><Trans i18nKey={'settings.account-full-normal'} /></BodyLarge>

        <div style={{marginBottom: 16}}>
          <OutlineButton dataTest="upgradeButton"
                         size={ButtonSize.Large}
                         text="button.upgrade-my-account"
                         click={onClick}
                         fullWidth={true}/>
        </div>
      </>}

      <PrimaryButton dataTest="doneButton"
                     size={ButtonSize.Large}
                     text="button.done-for-now"
                     click={props.onDone ?? onClick}
                     fullWidth={true}/>
    </>
  )
}

interface Props {
  // When set (e.g. inside a dialog), "done" hands control back to the host
  // instead of navigating away.
  onDone?: () => void;
}
